import React, { createContext, useEffect, useState, useContext } from 'react';
import api from '../services/api';
import { IConfiguration } from '../shared/interfaces';

interface ConfigurationContextData {
  configuration: IConfiguration | null;
}

const ConfigurationContext = createContext<ConfigurationContextData>(
  {} as ConfigurationContextData,
);

interface ICompanyProvider {
  children: any;
}

const ConfigurationProvider: React.FC<ICompanyProvider> = ({ children }) => {
  const [configuration, setConfiguration] = useState<IConfiguration | null>(
    null,
  );

  useEffect(() => {
    const token = sessionStorage.getItem('@Sigeclin:token');
    const clinic = sessionStorage.getItem('@Sigeclin:clinic');
    if (!token || !clinic || clinic === '0') return;
    api
      .get(`/configurations`)
      .then((response: any) => {
        if (response.data) {
          setConfiguration(response.data);
        }
      })
      .catch(() => console.log('Error to find company'));
  }, []);

  return (
    <ConfigurationContext.Provider value={{ configuration }}>
      {children}
    </ConfigurationContext.Provider>
  );
};

function useConfiguration(): ConfigurationContextData {
  const context = useContext(ConfigurationContext);

  if (!context) {
    throw new Error('useCompany must be used within a ConfigurationProvider');
  }

  return context;
}

export { ConfigurationProvider, useConfiguration };
